export default class ImageViewer {
    constructor(options)
    {
        this.options = _.merge(this.getDefaultOptions(), options);

        const activeThumbnail = $(this.options.selectors.thumbnail).first();
        this.setActiveThumbnail(activeThumbnail);

        this.registerEvents();
    }

    registerEvents()
    {
        const $thumbnails = $(this.options.selectors.thumbnail);
        const imageViewer = this;

        $thumbnails.click(function (e) {
            imageViewer.setActiveThumbnail(this);
        });

        $(this.options.selectors.btnPrevious).on('click', () =>{
            this.previous();
        });
        $(this.options.selectors.btnNext).on('click', () =>{
            this.next();
        });
    }

    getDefaultOptions()
    {
        return {
            selectors: {
                view: '.js-image-viewer-view',
                thumbnail: '.js-image-viewer-thumbnail',
                btnPrevious: '.js-image-viewer-btn-previous',
                btnNext: '.js-image-viewer-btn-next',
            },

            dataAttributes: {
                thumbnailSource: 'image-viewer-thumbnail-src'
            },

            classes: {
                thumbnailActive: 'active'
            },

            events: {
                onActiveThumbnailChanged(activeThumbnail, imageSource) {}
            }
        };
    }

    setViewerImageSource(imageSource)
    {
        const $view = $(this.options.selectors.view);

        $view.each(function (index, view) {
            view.src = imageSource;
        });

        this.viewerImageSource = imageSource;
    }

    setActiveThumbnail(activeThumbnail)
    {
        if (this.activeThumbnail === activeThumbnail) {
            return;
        }

        const $activeThumbnail = $(activeThumbnail);
        const imageSource = $activeThumbnail.data(this.options.dataAttributes.thumbnailSource);

        if (imageSource) {
            const $thumbnails = $(this.options.selectors.thumbnail);

            this.setViewerImageSource(imageSource);

            $thumbnails.removeClass(this.options.classes.thumbnailActive);
            $activeThumbnail.addClass(this.options.classes.thumbnailActive);

            this.options.events.onActiveThumbnailChanged(activeThumbnail, imageSource);

            this.activeThumbnail = $activeThumbnail.get()[0];
        }
    }

    previous()
    {
        let nextItem = $(this.activeThumbnail).first().parent().prev().find('.js-image-viewer-thumbnail');
        if (nextItem.length === 0) {
            nextItem = $(this.options.selectors.thumbnail).last();
        }

        this.setActiveThumbnail(nextItem);
    }

    next()
    {
        let nextItem = $(this.activeThumbnail).first().parent().next().find('.js-image-viewer-thumbnail');
        console.log(nextItem);
        if (nextItem.length === 0) {
            nextItem = $(this.options.selectors.thumbnail).first();
        }

        this.setActiveThumbnail(nextItem);
    }
}
